import {PulymDataTransferObject} from "../../../model/dto/pulym/PulymDataTransferObject";
import {RouteContext} from "../RouteContext";
import {Styles} from "../common/Styles";
import {DataTransferObjectValidation} from "../../../type/Types";
import {InputStringStatePair, StatePair, useError, useInputString, useStatePair} from "../../../type/States";
import {Button, Field, FieldProps, Radio, RadioGroup} from "@fluentui/react-components";
import {Column, Row} from "../common/Layout";

export default function Pulym(props: RouteContext) {
    const styles = Styles.useEditorStyles()

    const inputStates: Record<keyof PulymDataTransferObject.Post, InputStringStatePair> = {
        is_tomorrow: useInputString('false'),
    }
    const inputValidationStates: Record<keyof PulymDataTransferObject.Post, StatePair<FieldProps['validationState']>> = {
        is_tomorrow: useStatePair<FieldProps['validationState']>('none'),
    }
    const postErrorState = useError()

    const onDoneClick = () => {
        inputValidationStates.is_tomorrow.setValue('none')
        try {
            const dto: PulymDataTransferObject.Post = {
                is_tomorrow:  DataTransferObjectValidation.validate(PulymDataTransferObject.Post.validation, 'is_tomorrow', inputStates.is_tomorrow.value, () => inputValidationStates.is_tomorrow.setValue('error')),
            }

            fetch(`${process.env.REACT_APP_API_HOST}/api/v3/contents/shoppings/pulym`,
                {
                    method: 'POST',
                    headers: {
                        'content-type': 'application/json'
                    },
                    body: JSON.stringify(dto),
                },
            )
                .then(async value => {
                    const res = await value.json()
                    console.log(res)

                    if (!res) {
                        throw new Error('풀림 데이터 조회 후 저장 실패')
                    }

                    window.alert('추가되었습니다.')

                }).catch(postErrorState.setValue)

        }catch (error) {
            console.error(error)
        }
    }

    return <>
        <postErrorState.Dialog {...props} />
        <Column gap={'16px'}>
            <Field
                className={styles.field}
                label={PulymDataTransferObject.Post.description.is_tomorrow}
                validationState={inputValidationStates.is_tomorrow.value}>
                <RadioGroup
                    value={inputStates.is_tomorrow.value}
                    onChange={
                        (_, data) => inputStates.is_tomorrow.setValue(data.value)
                    }>
                    <Radio value="true" label="내일 일자 풀림데이터 가져오기" />
                    <Radio value="false" label="오늘 일자 풀림데이터 가져오기" />
                </RadioGroup>

            </Field>
            <Row>
                <Button
                    appearance={'primary'}
                    onClick={onDoneClick}>
                    제출하기
                </Button>
            </Row>
        </Column>
    </>
}